import { useMemo } from "react"

import { useMetricsListRecordDataTransport } from "@/metrics/transport-data"

import {
  buildMetricRecordInstancesById,
  buildMetricRecordsByKey,
} from "../utils/metricRecordLookups"

interface LookupHookOptions {
  enabled?: boolean
}

export const useMetricRecords = (options?: LookupHookOptions) => {
  const {
    data: rawMetricData,
    isLoading,
    isError,
    error,
  } = useMetricsListRecordDataTransport({
    enabled: options?.enabled,
  })

  const metricRecords = useMemo(
    () => buildMetricRecordsByKey(rawMetricData),
    [rawMetricData],
  )

  return {
    metricRecords,
    isLoading,
    isError,
    error,
  }
}

export const useMetricRecordsById = (options?: LookupHookOptions) => {
  const {
    data: rawMetricData,
    isLoading,
    isError,
    error,
  } = useMetricsListRecordDataTransport({
    enabled: options?.enabled,
  })

  const metricRecordsById = useMemo(
    () => buildMetricRecordInstancesById(rawMetricData),
    [rawMetricData],
  )

  return {
    metricRecordsById,
    isLoading,
    isError,
    error,
  }
}
